import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function GoogleCookiesRediClose() {
  
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };

  const clearCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };

    const updateStorage = ({
    access_token,
    refresh_token,
    username,
    connected,
    groups,
    is_superuser
  }) => {
    localStorage.setItem("ACCESS_TOKEN", access_token);
    localStorage.setItem("REFRESH_TOKEN", refresh_token);
    localStorage.setItem("username", username);
    localStorage.setItem("connected", JSON.stringify(connected));
    localStorage.setItem("groups", groups);
    localStorage.setItem("is_superuser", JSON.stringify(is_superuser));
  };

  useEffect(() => {

    const interval = setInterval(() => {
      
      setCount((prevCount) => prevCount + 1);

      const email = getCookie("email");

      if (email) {
          const userData = {
            access_token: getCookie("access_token"),
            refresh_token: getCookie("refresh_token"),
            username: getCookie("username"),
            connected: true,
            groups: getCookie("groups")?.replace(/\|/g, ","),
            is_superuser: getCookie("is_superuser") === "True"
          };

          updateStorage(userData);
          clearInterval(interval);

          navigate("/Home");
          window.location.reload();

      }
    }, 500);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  // =========================
  // UI
  // =========================
  return (
    <div>
      <div className="message_">
        Logging you in... {count}
      </div>

      <style>{`
        .message_ {
          color: green;
          font-size: 20px;
          text-align: center;
        }
      `}</style>
    </div>
  );
}
